import { render, staticRenderFns } from "./save-search-dialog.vue?vue&type=template&id=067b1288&scoped=true&"
import script from "./save-search-dialog.vue?vue&type=script&lang=js&"
export * from "./save-search-dialog.vue?vue&type=script&lang=js&"
import style0 from "./save-search-dialog.vue?vue&type=style&index=0&id=067b1288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b1288",
  null
  
)

export default component.exports